import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/main'
import Intelligent from '@/components/intelligentCRM'
import Live from '@/components/liveBroadcast'
import Customer from '@/components/customerService'
import Contact from '@/components/contactUs'
import Index from '@/components/index'
import Project from '@/components/project'
import WheatSchool from '@/components/wheatSchool'

import Error from '@/components/404'
Vue.use(Router);
export default new Router({
  // history:true,
  // mode: 'history',
  // base: '/enterprise_pc/',
  routes: [
    {
      path:'/',
      name:'index',
      component:Index,
      children:[
        {
          path:'index',
          name:'main',
          meta:{title:'首页'},
          component:Main //首页
        },
        {
          path:'/',
          name:'main',
          meta:{title:'首页'},
          component:Main //首页
        },
        {
          path:'intelligent',
          name:'intelligent',
          meta:{title:'智能CRM'},
          component:Intelligent
        },
        {
          path:'project',
          name:'project',
          meta:{title:'经营管控'},
          component:Project
        },
        {
          path:'live',
          name:'live',
          meta:{title:'直播'},
          component:Live
        },
        {
          path:'customer',
          name:'customer',
          meta:{title:'微客服'},
          component:Customer
        },
        {
          path:'contact',
          name:'contact',
          meta:{title:'联系'},
          component:Contact
        },
        {
          path: '/wheatSchool',
          name: 'wheatSchool',
          meta:{title:'小麦学堂'},
          component: WheatSchool
        }
      ]
    },
    {
      path:'/404',
      name:'404',
      component:Error
    }
  ],
  scrollBehavior: () => ({y: 0})
})



// WEBPACK FOOTER //
// ./src/router/index.js